export default ({ request }) => ({
  userTripReimbursementListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/list',
      method: 'POST',
      data
    })
  },
  userTripReimbursementDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/detail',
      method: 'POST',
      data
    })
  },
  userTripReimbursementSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/save',
      method: 'POST',
      data
    })
  },
  userTripReimbursementDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/del',
      method: 'POST',
      data
    })
  },
  userTripReimbursementRejectedApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/force/reject',
      method: 'POST',
      data
    })
  },
  userTripReimbursementAddApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/add',
      method: 'POST',
      data
    })
  },
  userTripReimbursementItemListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/item/list',
      method: 'POST',
      data
    })
  },
  userTripReimbursementItemSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/item/save',
      method: 'POST',
      data
    })
  },
  userTripReimbursementItemDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/item/detail',
      method: 'POST',
      data
    })
  },
  userTripReimbursementItemDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/item/del',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/list',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportEditDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/editDetail',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/detail',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/save',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/del',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDocListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/doc/list',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDocBatchUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/doc/batchUpload',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDocDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/doc/detail',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDocUpdateApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/doc/update',
      method: 'POST',
      data
    })
  },
  userTripReimbursementReportDocDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/report/doc/del',
      method: 'POST',
      data
    })
  },
  userTripReimbursementOaApply(data = {}) {
    return request({
      url: '/oa/usertrip/reimbursement/apply',
      method: 'post',
      data
    })
  },
  userTripReimbursementAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/reimbursement/audit',
      method: 'post',
      data
    })
  }
})
